import React from 'react'

export const getStudentAwardColumns = (layout, role, studentId, isStudentView, handleDelete, isProfile = false, openEditModal) => {
	const columns = [
	{
		name: '#',
		selector: (row) => row.sortorder,
		sortable: true,
		width: '8%'
	},
	{
		name: 'Recog. Level',
		selector: (row) => row.recoglevel,
		sortable: true,
		width: '15%',
		center: true
	},
	{
		name: 'Ranking',
		selector: (row) => row.ranking,
		sortable: true,
		width: '12%',
		center: true
	},
	{
		name: 'Grade Level',
		selector: (row) => row.gradelevel,
		sortable: true,
		width: '12%',
		center: true
	},
	{
		name: 'Award',
		selector: (row) => row.description,
		sortable: true,
		width: '25%',
		cell: (row) => (
			<div className="text-truncate" style={{ maxWidth: '100%' }} title={row.description}>
				{row.description}
			</div>
		)
		}
	]

	// Add Actions column only if not in profile view
	if (!isProfile) {
		columns.push({
		name: 'Actions',
		cell: (row) => (
			<div className="d-flex gap-1">
				<button
					onClick={() => openEditModal(row.id)}
					className="btn btn-success btn-sm"
				>
					<i className="fa fa-edit me-1"></i>
				</button>
				<button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.id)}>
					 <i className="fa fa-trash"></i>
				</button>
			</div>
		),
		width: '25%',
		center: true,
		ignoreRowClick: true
		})
	}

	return columns
}
